import { useState, useEffect } from 'react';
import axios from 'axios';
import { savedevices } from '../components/DbServices';
import { whatsappapi } from '../api/api';
import { getStoredUser } from '../utilities/encryption';

import Swal from 'sweetalert2';

export default function AddDeviceModal({ onClose, device, reconnect }) {
  const user = getStoredUser();
  const userId = user.data.id;
 

  const [step, setStep] = useState(reconnect ? 2 : 1);

  const [phoneNumber, setPhoneNumber] = useState('');
  const [deviceName, setDeviceName] = useState('');
  const [sessionId, setSessionId] = useState(null);
  const [qr, setQr] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
 

  /* 🔁 POLL QR FROM NODE */
  useEffect(() => {
    if (!sessionId || step !== 2) return;
    const interval = setInterval(async () => {
      try {
        const res = await axios.get(`${whatsappapi}/device/qr/${sessionId}`);
        if (res.data?.qr) setQr(res.data.qr);
      } catch (err) { console.error('QR polling failed'); }
    }, 3000);
    return () => clearInterval(interval);
  }, [sessionId, step]);

  /* 🔁 POLL STATUS FROM NODE */
  useEffect(() => {
    if (!sessionId || step !== 2) return;
    const statusInterval = setInterval(async () => {
      try {
        const res = await axios.get(`${whatsappapi}/device/status/${sessionId}`);
        if (['authenticated', 'device connected', 'connected'].includes(res.data?.status)) {
          setStep(3);
          clearInterval(statusInterval);
        }
      } catch (err) { console.error('Status polling failed'); }
    }, 3000);
    return () => clearInterval(statusInterval);
  }, [sessionId, step]);

  // const startConnection = async () => {
  //   setError('');
  //   if (!deviceName || !phoneNumber) return setError('Please fill all fields');
  //   if (!/^\d{10,15}$/.test(phoneNumber)) return setError('Enter valid phone number with country code');

  //   try {
  //     setLoading(true);
  //     const saveRes = await savedevices({
  //       user_id: userId,
  //       device_name: deviceName,
  //       phone_number: phoneNumber,
  //       subscriptionId: user.data.subscription_id
  //     });

  //     if (saveRes?.status !== 200) return setError('Failed to create device');

  //     setSessionId(saveRes.data.session_id);
  //     await axios.post(`${whatsappapi}/device/start`, {
  //       session_id: saveRes.data.session_id,
  //       device_id: saveRes.data.id
  //     });
  //     setStep(2);
  //   } catch (err) {
  //     setError('Unable to start device. Try again.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };



  const startConnection = async () => {
    setError('');
  
    try {
      setLoading(true);
  
      // 🔄 RECONNECT FLOW (NO INSERT)
      if (reconnect && device) {
        setSessionId(device.session_id);
  
        await axios.post(`${whatsappapi}/device/reconnect`, {
          session_id: device.session_id,
          device_id: device.id
        });
  
        setStep(2);
        return;
      }
  
      // ➕ NEW DEVICE FLOW (INSERT ONCE)
      if (!deviceName || !phoneNumber) {
        return setError('Please fill all fields');
      }
  
      if (!/^\d{10,15}$/.test(phoneNumber)) {
        return setError('Enter valid phone number with country code');
      }
  
      const saveRes = await savedevices({
        user_id: userId,
        device_name: deviceName,
        phone_number: phoneNumber,
        subscriptionId: user.data.subscription_id
      });
  
      if (saveRes?.status !== 200) {
        return setError('Failed to create device');
      }
  
      setSessionId(saveRes.data.session_id);
  
      await axios.post(`${whatsappapi}/device/start`, {
        session_id: saveRes.data.session_id,
        device_id: saveRes.data.id
      });
  
      setStep(2);
  
    } catch (err) {
      setError('Unable to start device. Try again.');
    } finally {
      setLoading(false);
    }
  };

  
  return (
    <div className="custom-modal-backdrop" style={{ alignItems: 'center' }}>
      <div className="custom-modal border-0 shadow-lg" style={{ maxWidth: '500px', width: '95%', borderRadius: '20px', overflow: 'hidden', padding: '0' }}>
        
        {/* Header with Gradient */}
        <div className="bg-primary p-4 text-white text-center">
        <h5 className="fw-bold mb-0">
  {reconnect ? '🔄 Reconnect Device' : '➕ New Device'}
</h5>

          <div className="d-flex justify-content-center gap-2 mt-3">
            {[1, 2, 3].map(i => (
              <div key={i} style={{ 
                width: '30px', height: '6px', 
                borderRadius: '10px', 
                backgroundColor: step >= i ? '#fff' : 'rgba(255,255,255,0.3)',
                transition: '0.3s'
              }}></div>
            ))}
          </div>
        </div>

        <div className="p-4 bg-white">
          {error && <div className="Swal Swal-danger small border-0 shadow-sm mb-4">{error}</div>}

          {/* STEP 1: CONFIGURATION */}
          {step === 1 && (
            <div className="fade-in">
              <label className="small fw-bold text-muted mb-1 text-uppercase">1. Device Identity</label>
              <input
                className="form-control form-control-lg mb-3 shadow-none border-2"
                style={{ borderRadius: '12px', fontSize: '15px' }}
                placeholder="e.g. Customer Support"
                value={deviceName}
                onChange={e => setDeviceName(e.target.value)}
              />

              <label className="small fw-bold text-muted mb-1 text-uppercase">2. Phone Number</label>
              <input
                className="form-control form-control-lg mb-4 shadow-none border-2"
                style={{ borderRadius: '12px', fontSize: '15px' }}
                placeholder="919876543210"
                value={phoneNumber}
                onChange={e => setPhoneNumber(e.target.value)}
              />

              <button className="btn btn-primary btn-lg w-100 fw-bold shadow-sm" style={{ borderRadius: '12px' }} onClick={startConnection} disabled={loading}>
                {loading ? <><span className="spinner-border spinner-border-sm me-2"></span>Connecting...</> : 'Generate QR Code'}
              </button>
            </div>
          )}

          {/* STEP 2: SCANNING */}
          {step === 2 && (
            <div className="text-center fade-in">
              <h6 className="fw-bold mb-2">Scan QR Code</h6>
              <p className="text-muted small mb-4">Open WhatsApp on your phone &gt; Linked Devices &gt; Link a Device</p>

              <div className="d-inline-block p-3 bg-white border border-2 rounded-4 shadow-sm mb-4">
                {qr ? (
                  <img src={qr} alt="QR Code" style={{ width: '220px', borderRadius: '10px' }} />
                ) : (
                  <div style={{ width: '220px', height: '220px' }} className="d-flex align-items-center justify-content-center">
                    <div className="spinner-border text-primary"></div>
                  </div>
                )}
              </div>

              <div className="Swal bg-light border-0 small text-start">
                <i className="bi bi-info-circle-fill text-primary me-2"></i>
                Keep this window open. The screen will automatically refresh once the connection is successful.
              </div>
            </div>
          )}

          {/* STEP 3: SUCCESS */}
          {step === 3 && (
            <div className="text-center py-4 fade-in">
              <div className="mb-3 animate-bounce">
                <span style={{ fontSize: '60px' }}>🎉</span>
              </div>
              <h4 className="fw-bold text-success">Device Ready!</h4>
              <p className="text-muted px-4">Your instance is now authenticated and ready to send messages.</p>
              <button className="btn btn-success btn-lg w-100 mt-3 shadow-sm" style={{ borderRadius: '12px' }} onClick={onClose}>
                Go to Dashboard
              </button>
            </div>
          )}

          {step < 3 && (
            <button className="btn btn-link btn-sm w-100 mt-3 text-muted text-decoration-none" onClick={onClose} disabled={loading}>
              Cancel Setup
            </button>
          )}
        </div>
      </div>
    </div>
  );
}